export const vars = {
    ALERT_TIME: 5000,
}
